// start:ng42.barrel
export * from './room.model';
// end:ng42.barrel



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/model/reservation/room/index.ts